import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/linqops/linqops/apps/mainApp/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/linqops/linqops/apps/mainApp/node_modules/next/dist/client/image-component.js");
